// [DEV MN]

let current_url = window.location.pathname;

// Header Sub Menu open/close on mouse enter and leave
var menuItem = document.querySelectorAll('.header__inline-menu details')
if (menuItem.length > 0){
  for(let i=0; i<menuItem.length; i++){
    menuItem[i].addEventListener('mouseenter', function() {
      this.setAttribute('open', 'open')
      this.children[0].classList.add('hover')
//       document.querySelector('.announcement-bar').style.display = 'none'
    })
    menuItem[i].addEventListener('mouseleave', function() {
      this.removeAttribute('open')
      this.children[0].classList.remove('hover')
//       document.querySelector('.announcement-bar').style.display = 'block'
    })
  }
}

// Homepage Main Slider
let button = document.querySelectorAll(".homepage-slider .swiper-button");
if(document.querySelectorAll(".homepage-slider .swiper-slide").length == 1) {
    for(let i=0; i<button.length; i++){
        button[i].style.display = "none"
    }
}else{
    for(let i=0; i<button.length; i++){
        button[i].style.display = "block"
    }
    const homepageSlideshow = new Swiper(".homepage-slider", {
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

// Homepage Brands Slider
const brands = new Swiper(".brands-wrapper", {
    loop: true,
    slidesPerView: 7,
    autoplay: {
      delay: 1500, 
      disableOnInteraction: false,
    },
    breakpoints: {
        280: {
          slidesPerView: 3,
        },

        768: {
          slidesPerView: 4,
        },

        1024: { 
          slidesPerView: 5,
        },

        1200: {
            slidesPerView: 6,
        },

        1300: {
            slidesPerView: 7,
        },
      },
});

// variant image changer on product grids 
let item  = document.querySelectorAll('.cstm-color-variants .item-image-wrapper')
if (item.length > 0){
  for(let i=0; i<item.length; i++){
    item[i].addEventListener('click', function(e){
      e.preventDefault()
      let variantImage = this.getAttribute('data-img')
      let productImageNode = this.closest('.card-wrapper').lastElementChild.children[0].children[0].children[0].children[0];
      productImageNode.setAttribute('src', variantImage);
      productImageNode.setAttribute('srcset', variantImage);
    });
  }
}

// Homepage Featured Products Slider
var productWrapper = document.querySelectorAll('.products-wrapper')
if (productWrapper.length > 0){
  for (let i=0; i<productWrapper.length; i++){
    if (productWrapper[i].classList.contains('grid--3')){
      const product = new Swiper(productWrapper[i], {
        slidesPerView: 2,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
        breakpoints: {
          768: { 
            slidesPerView: 2,
          },

          1024: { 
            slidesPerView: 3,
          },
        },

        on: {
          slideChange: function () {
            sliderCounter(this)
          },
        },
      });

    }else{
      const product = new Swiper(productWrapper[i], {
        slidesPerView: 2,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
        breakpoints: {
          768: { 
            slidesPerView: 3,
          },

          1024: { 
            slidesPerView: 4,
          },
        },

        on: {
          slideChange: function () {
            sliderCounter(this)
          },
        },
      });
    }
  }
}

// Homepage Featured Products Slider Counter
function sliderCounter(obj){
  var activeSlide = obj.activeIndex + 1
  let counter = document.querySelectorAll('.counter-wrapper .cstm-counter')
  if (counter.length > 0){
    for (let i=0; i<counter.length; i++){
      counter[i].innerText = `0${activeSlide}`
    }
  }
}

// Homepage Featured Products Total Count
let pagination = document.querySelectorAll('.swiper-pagination');
if (pagination.length > 0){
    for(let i=0; i<pagination.length; i++){
        let totalCount = pagination[i].lastElementChild.innerText 
        let element = pagination[i].closest('.swiper-container').children[4].children[1]
        element.innerText = '0'+totalCount
    }
}

// If customer is already subscribed
if(window.location.href.match('form_type=customer')){
  var alreadyNode = document.querySelectorAll('.already-subscribed');
  if (alreadyNode.length > 0){
    alreadyNode.forEach(function(i){
      i.style.display = 'block'
    })
  }
}

//   Modal script js
let modalTrigger = document.querySelectorAll('[data-role=modal-trigger]')
let modal = document.querySelectorAll('.cstm-modal')
let closeButton = document.querySelectorAll('[modal-close]')
for(let i=0; i< modalTrigger.length; i++){
    modalTrigger[i].addEventListener('click', function() {
        let getModalId = this.getAttribute('modal-target');
        document.querySelector(getModalId).style.display = 'flex' 
        document.querySelector('body').style.overflow = 'hidden' 
    })	
}
// when click on close button on modal
for(let i=0; i< closeButton.length; i++){
  closeButton[i].addEventListener('click', function() {
      for(let i=0; i< modal.length; i++){
        modal[i].style.display = 'none' ;
        document.querySelector('body').style.overflow = 'visible' ;
      }
  })
}

$(modal).mouseup(e => {
  if (!$('.cstm-modal-content').is(e.target) && $('.cstm-modal-content').has(e.target).length === 0){
    $(modal).css('display', 'none');
    $('body').css('overflow', 'visible');
  }
});

// Load More functionality on collection page

// Load More Button
if (current_url.includes('collections')) {
 
  var products_on_page = document.getElementById("product-grid");
  var next_url = products_on_page.getAttribute('data-next-url');
  var loadmore_btn = document.querySelector(".load-more-cstm-btn");
  var loadmore_spinner = document.querySelector(".load-more-spinner");
  var no_more = document.querySelector(".no-more-cstm");
  
  no_more.style.display = "none";

  function loadMoreProducts(){ 
      fetch(next_url)
      .then((response)=>{
        loadmore_btn.style.display = "none";
        loadmore_spinner.style.display = "inline-block";
        return response.text();
      })
      .then((data)=>{
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        let return_html = doc.body;
        let main_html = return_html.querySelector('#product-grid');
        let main_html_child = main_html.querySelectorAll('.grid__item');
        let new_url = main_html.getAttribute('data-next-url');
        loadmore_spinner.style.display = "none";
        if(new_url){
          loadmore_spinner.style.display = "inline-block";
          loadmore_btn.style.display = "none";
        }
        next_url = new_url;
        setTimeout(()=>{
                  main_html_child.forEach(function(value, index){
          document.querySelector('.product-grid').append(value)	
        })
        loadmore_spinner.style.display = "none";
        if(new_url){
          loadmore_btn.style.display = "block";
//            // variant image changer on product grids 
let item  = document.querySelectorAll('.cstm-color-variants .item-image-wrapper')
if (item.length > 0){
  for(let i=0; i<item.length; i++){
    item[i].addEventListener('click', function(e){
      e.preventDefault()
      let variantImage = this.getAttribute('data-img')
      let productImageNode = this.closest('.card-wrapper').lastElementChild.children[0].children[0].children[0].children[0];
      productImageNode.setAttribute('src', variantImage);
      productImageNode.setAttribute('srcset', variantImage);
    });
  }
}
        }
        else{
          loadmore_btn.style.display = "none";
          no_more.style.display = "block";
        }

      },600)
    })
    .catch((err)=>{
      console.log(err);
    })
  }

  if(document.querySelectorAll('#load-more-cstm-btn').length > 0){
    document.querySelector('#load-more-cstm-btn').addEventListener('click', ()=>{
      loadMoreProducts()
    });
  }

}

jQuery(".country_changer").click(function(){
	jQuery(".countries-show").toggle();
  $(".icon-caret").toggleClass("rotate")
});

$('body').click(e => {
  if (!$('.country_changer').is(e.target) && $('.country_changer').has(e.target).length === 0){
    $('.countries-show').css('display', 'none');
    $(".icon-caret").removeClass("rotate")
  }
});

// Main product image change on the basis of variant images on product page
$('.mn_variants .color-swatch img').on('click', function(){
  var src = $(this).attr('data-src')
  var imgSrc = $(this).attr('data-img-src')
  $('.mn_pro-thumbnails-wrapper').find('.swiper-slide-thumb-active').removeClass('swiper-slide-thumb-active')
  $('.mn_pro-featured-wrapper').find('.swiper-slide-active img').attr('src', imgSrc)
  $('.mn_pro-featured-wrapper').find('.swiper-slide-active').attr('data-zoom-image', imgSrc).zoom()
  $('.mn_pro-featured-wrapper').find(`.filter-${src}`).addClass('swiper-slide-active')
  $('.mn_pro-thumbnails-wrapper').find(`.filter-${src}`).addClass('swiper-slide-thumb-active').trigger('click')
})